import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { dispatchEvent } from 'src/helpers/tagManager'
import { FormattedMessage } from 'react-intl'

import {
  NDStateWarnLoad,
  NDStateWarnTuneClick,
  NDStateLooksGoodClick
} from 'src/constants/trackingEvents'
import { handleAcknowledgeTuneValue } from 'src/actions/homeowner'
import { selectHomeAddressStateName } from 'store/selectors/home'
import { hasCustomerToken } from 'src/auth'

import { Button, Text, If } from 'src/Components'
import WarningLayout from './WarningLayout'

import styles from './Warnings.module.scss'

const NonDisclosureStateWarning = ({ onNavigate }) => {
  const dispatch = useDispatch()
  const stateName = useSelector(selectHomeAddressStateName)

  useEffect(() => {
    dispatchEvent(NDStateWarnLoad)
  }, [])

  const handleClickCurry = action => {
    return () => {
      dispatchEvent(NDStateLooksGoodClick)
      dispatch(action())
    }
  }

  const handleNavigate = () => {
    dispatchEvent(NDStateWarnTuneClick)
    onNavigate()
  }

  return (
    <WarningLayout type='error'>
      <Text
        element='div'
        color='white'
        align='left'
        className={styles.calloutMessage}
      >
        <FormattedMessage
          id='Homeowner.estimatedValue.nonDisclosureStateWarning'
          defaultMessage='{stateName} limits the amount of data Homebot can access and this can create an accuracy issue.'
          values={{ stateName }}
        />
        <If condition={!hasCustomerToken()}>
          <Button.Group className={styles.calloutButtons}>
            <Button onClick={handleNavigate}>
              <FormattedMessage
                id='Homeowner.estimatedValue.nonDisclosureStateWarning.tuneValue'
                defaultMessage='Tune value'
              />
            </Button>
            <Button onClick={handleClickCurry(handleAcknowledgeTuneValue)}>
              <FormattedMessage
                id='Homeowner.estimatedValue.nonDisclosureStateWarning.looksGood'
                defaultMessage='Looks good'
              />
            </Button>
          </Button.Group>
        </If>
      </Text>
    </WarningLayout>
  )
}

export default NonDisclosureStateWarning
